<template>
    <div class="f fh fa-c oh ath-visual-section-title">
        <VisualIcon v-if="icon"
            :name="icon"
            :uiSize="iconSize"
            class="sm-r-xs"
            :class="[iconCname]" />
        <h4 class="f fh fa-c fg o-ol">
            <span class="fi ath-visual-section-title-el" v-html="data.uiText"></span>
            <slot name="labelAfter"></slot>
        </h4>
        <slot name="labelRight"></slot>
    </div>
</template>

<script>
import { isNeString } from '@aretheyhappy/utils';
import VisualIcon from '../visuals/Icon.vue';

export default {
    name: 'mead-section-title',
    components: {VisualIcon},
    props: {
        /**
         * Name of an icon to render before the title. Passed through to the
         * `Icon` component. Defaults to `false`, which hides the icon entirely.
         */
        icon        : {type: [Boolean, String], default: () => false},
        /**
         * Additional class(es) applied to the icon, when `icon` is set.
         */
        iconCname   : {type: String, default: () => ''},
        /**
         * Size passed through to the icon's `uiSize` prop (e.g. "s", "m", "l").
         */
        iconSize    : {type: String, default: () => 'l'},
        /**
         * The section title text. Non-empty strings are passed through I18N
         * translation and rendered as HTML. Defaults to `false`, which renders
         * as "???".
         */
        name        : {type: [Boolean, String], default: () => false},
    },
    computed: {
        data: function () {
            return {
                uiText: isNeString(this.name) ? MeadCommon.I18N.go(this.name) : '???',
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../../../sass/variables' as *;

.ath-visual-section-title-el {
    font-size: $fs-m;
    font-style: normal;
    font-family: $ff-he;
    font-weight: 600;
    color: var(--c-txt);

    strong {
        font-weight: 600;
    }
}
</style>
